import React from 'react';

interface ArticleCardSkeletonProps {
  featured?: boolean;
}

export default function ArticleCardSkeleton({ featured = false }: ArticleCardSkeletonProps) {
  if (featured) {
    return (
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 bg-white rounded-lg shadow-md overflow-hidden p-0">
        <div className="h-64 md:h-auto bg-gray-200 animate-pulse"></div>
        <div className="p-8 flex flex-col">
          <div className="flex gap-2 mb-3">
            <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="h-6 w-20 bg-gray-200 rounded-full animate-pulse"></div>
          </div>
          <div className="h-10 w-3/4 bg-gray-200 mb-4 animate-pulse"></div>
          <div className="space-y-2 mb-6 flex-grow">
            <div className="h-5 bg-gray-200 animate-pulse"></div>
            <div className="h-5 bg-gray-200 animate-pulse"></div>
            <div className="h-5 w-2/3 bg-gray-200 animate-pulse"></div>
          </div>
          <div className="flex justify-between items-center mt-auto">
            <div className="flex items-center gap-3">
              <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse"></div>
              <div className="h-5 w-24 bg-gray-200 animate-pulse"></div>
            </div>
            <div className="h-5 w-32 bg-gray-200 animate-pulse"></div>
          </div>
          <div className="mt-5 h-6 w-28 bg-gray-200 animate-pulse"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-white rounded-lg shadow-md overflow-hidden h-full">
      <div className="h-56 bg-gray-200 animate-pulse"></div>
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex gap-2 mb-3">
          <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse"></div>
          <div className="h-6 w-20 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
        <div className="h-7 w-3/4 bg-gray-200 mb-3 animate-pulse"></div>
        <div className="space-y-2 mb-6 flex-grow">
          <div className="h-5 bg-gray-200 animate-pulse"></div>
          <div className="h-5 w-3/4 bg-gray-200 animate-pulse"></div>
        </div>
        <div className="flex justify-between items-center mt-auto">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse"></div>
            <div className="h-5 w-24 bg-gray-200 animate-pulse"></div>
          </div>
          <div className="h-5 w-32 bg-gray-200 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}